/* eslint-disable */
import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import {
  NavList,
  NavListItem,
  NavListFlyout,
  NavListFlyoutLink,
} from 'components/nav-list'

const AuthNav = ({ location, showAddPolicy }) => {
  return (
    <NavList location={location}>
      <NavListItem
        location={location}
        to='/app/policies/'
        renderFlyout={props => (
          <NavListFlyout {...props}>
            <NavListFlyoutLink to='/app/policies/'>
              Active Policies
            </NavListFlyoutLink>
            <NavListFlyoutLink to='/app/policies/expired/'>
              Expired Policies
            </NavListFlyoutLink>
            {showAddPolicy && (
              <NavListFlyoutLink to='/app/policies/add/'>
                Add Policy
              </NavListFlyoutLink>
            )}
          </NavListFlyout>
        )}
      >
        Policies
      </NavListItem>
      <NavListItem
        location={location}
        to='/app/payments/'
        renderFlyout={props => (
          <NavListFlyout {...props}>
            <NavListFlyoutLink to='/app/payments/'>
              Upcoming Payments
            </NavListFlyoutLink>
            <NavListFlyoutLink to='/app/payments/history/'>
              Payment History
            </NavListFlyoutLink>
            <NavListFlyoutLink to='/app/payments/payment-methods/'>
              Payment Methods
            </NavListFlyoutLink>
          </NavListFlyout>
        )}
      >
        Payments
      </NavListItem>
      <NavListItem to='/app/credit/'>Credit</NavListItem>
      {/* <NavListItem to='/app/make-claim/'>Make a Claim</NavListItem> */}
    </NavList>
  )
}

AuthNav.propTypes = {
  showAddPolicy: PropTypes.bool,
  location: PropTypes.shape({}),
}

AuthNav.defaultProps = {
  showAddPolicy: false,
  location: {},
}

const mapStateToProps = ({ user: { entityId } }) => ({
  showAddPolicy: Boolean(entityId),
})

export default connect(mapStateToProps)(AuthNav)
